module.exports = __webpack_public_path__ + "img/voice3.2a983763.png";